import { Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function GetStartedStepRow({ icon, label, complete, actionLabel, onAction, disabled }) {
    return (
        <ListItemBox spacing={1.5} sx={{ py: 1, px: 3, minHeight: 56 }}>
            <Iconify
                icon={icon}
                sx={{
                    width: 24,
                    height: 24,
                    color: complete ? "text.disabled" : "primary.main",
                }}
            />
            <Typography
                variant="body1"
                sx={{
                    flex: 1,
                    textDecoration: complete ? "line-through" : "none",
                    color: complete ? "text.secondary" : "text.primary",
                }}
            >
                {label}
            </Typography>
            <If value={complete}>
                <Typography
                    variant="body2"
                    sx={{ color: "primary.main", cursor: "pointer", fontWeight: 600 }}
                    onClick={onAction}
                >
                    View
                </Typography>
                <Iconify icon="eva:checkmark-circle-2-fill" sx={{ width: 24, height: 24, color: "primary.main" }} />
                <Else>
                    <Typography
                        variant="body2"
                        onClick={disabled ? undefined : onAction}
                        sx={{
                            color: disabled ? "text.disabled" : "primary.main",
                            cursor: disabled ? "default" : "pointer",
                            fontWeight: 600,
                        }}
                    >
                        {actionLabel}
                    </Typography>
                </Else>
            </If>
        </ListItemBox>
    )
}
